module.exports = __webpack_public_path__ + "assets/edit-camp-title.327dfc80.svg";